
export default function ChangeSign({change, vol_qty, base_price, last_price, lower_price, upper_price}) {
    var sq = false;
    if (vol_qty == 0 && base_price != last_price) {                        
        sq = true;
    }
    var tmpHtml = '';

    if (sq) {
        if (change > 0) {
            if (last_price == upper_price) {                                
                tmpHtml = <img className="w-1rem h-auto" src="/img/sq_upper_sign.png" />;
            } else {                                
                tmpHtml = <img className="w-1rem h-auto" src="/img/sq_up_sign.png" />;
            }                            
        } else if (change == 0) {
            tmpHtml = <img className="w-1rem h-auto" src="/img/unchange_sign.png" />;
        } else {
            if (last_price == lower_price) {
                tmpHtml = <img className="w-1rem h-auto" src="/img/sq_lower_sign.png" />;
            } else {
                tmpHtml = <img className="w-1rem h-auto" src="/img/sq_low_sign.png" />;
            }
        }
    } else {
        if (change > 0) {
            if (last_price == upper_price) {                                
                tmpHtml =  <img className="w-1rem h-auto" src="/img/upper_sign.png" />;
            } else {           
                tmpHtml = <img className="w-1rem h-auto" src="/img/up_sign.png" />;
            }                            
        } else if (change == 0) {
            tmpHtml = <img className="w-1rem h-auto" src="/img/unchange_sign.png" />;
        } else {
            if (last_price == lower_price) {
                tmpHtml = <img className="w-1rem h-auto" src="/img/lower_sign.png" />;
            } else {
                tmpHtml = <img className="w-1rem h-auto" src="/img/low_sign.png" />;
            }
        }
    }

    return (
        <span className="h-auto">{tmpHtml}&nbsp;</span>
    );
}